// src/components/Relation/Relation.js
import React, { useEffect, useState, useCallback } from 'react';
import './Relation.css';

const Relation = ({ relation, onDelete, onEdit, isHighlighted = false }) => {
  const [coordinates, setCoordinates] = useState({ x1: 0, y1: 0, x2: 0, y2: 0 });
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  const updatePosition = useCallback(() => {
    console.log('[Relation] Updating position for relation:', relation);
    if (typeof document === 'undefined') return;

    const startElement = document.querySelector(
      `[data-lane-id="${relation.startBox.laneId}"][data-box-id="${relation.startBox.boxId}"]`
    );
    const endElement = document.querySelector(
      `[data-lane-id="${relation.endBox.laneId}"][data-box-id="${relation.endBox.boxId}"]`
    );
    const svg = document.querySelector('.lines-container');

    console.log('[Relation] Start element:', startElement);
    console.log('[Relation] End element:', endElement);
    console.log('[Relation] SVG element:', svg);

    if (startElement && endElement && svg) {
      const startRect = startElement.getBoundingClientRect();
      const endRect = endElement.getBoundingClientRect();

      const getLocalCoords = (x, y) => {
        const pt = svg.createSVGPoint();
        pt.x = x;
        pt.y = y;
        return pt.matrixTransform(svg.getScreenCTM().inverse());
      };

      const startLocal = getLocalCoords(
        startRect.left + startRect.width / 2,
        startRect.bottom
      );

      // Find the subband element for this relation
      const subband = endElement.querySelector(`[data-relation-id="${relation.id}"]`);
      console.log('[Relation] Subband element:', subband);

      let endLocal;
      if (subband) {
        const subbandRect = subband.getBoundingClientRect();
        endLocal = getLocalCoords(
          subbandRect.left + subbandRect.width / 2,
          subbandRect.top
        );
      } else {
        // Fallback to the top center of the end box if subband is not found
        endLocal = getLocalCoords(
          endRect.left + endRect.width / 2,
          endRect.top
        );
      }

      const newCoordinates = {
        x1: startLocal.x,
        y1: startLocal.y,
        x2: endLocal.x,
        y2: endLocal.y
      };
      console.log('[Relation] New coordinates:', newCoordinates);
      setCoordinates(newCoordinates);
    } else {
      console.warn('[Relation] Could not find elements to draw relation');
    }
  }, [relation]);

  useEffect(() => {
    console.log('[Relation] Relation component mounted/updated');
    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, [updatePosition]);

  useEffect(() => {
    const observer = new MutationObserver(updatePosition);
    observer.observe(document.body, { 
      attributes: true, 
      childList: true, 
      subtree: true 
    });
    return () => observer.disconnect();
  }, [updatePosition]);

  const handlePercentageClick = (e) => {
    e.preventDefault();
    setShowMenu(true);
    setMenuPosition({ x: e.clientX, y: e.clientY });
  };

  const handleMenuClick = (e) => {
    e.stopPropagation();
    setShowMenu(false);
  };

  console.log('[Relation] Rendering relation:', relation);
  console.log('[Relation] Coordinates:', coordinates);

  return (
    <g className={isHighlighted ? 'relation-highlighted' : ''}>
      <line
        x1={coordinates.x1}
        y1={coordinates.y1}
        x2={coordinates.x2}
        y2={coordinates.y2}
        stroke={isHighlighted ? "#F59E0B" : "blue"}
        strokeWidth={isHighlighted ? "4" : "2"}
        className={`relation-line-visual ${isHighlighted ? 'highlighted' : ''}`}
        data-testid="relation-line"
      />
      <line
        x1={coordinates.x1}
        y1={coordinates.y1}
        x2={coordinates.x2}
        y2={coordinates.y2}
        stroke="transparent"
        strokeWidth="10"
        className="relation-line-interactive"
        onClick={handlePercentageClick}
      />
      <text
        x={(coordinates.x1 + coordinates.x2) / 2}
        y={(coordinates.y1 + coordinates.y2) / 2 - 10}
        textAnchor="middle"
        dominantBaseline="bottom"
        fill="black"
        onClick={handlePercentageClick}
        style={{ cursor: 'pointer' }}
      >
        {relation.percentage}%
      </text>
      {showMenu && (
        <foreignObject 
          x={menuPosition.x} 
          y={menuPosition.y}
          width="100" 
          height="70"
        >
          <div className="relation-menu">
            <button onClick={(e) => { onEdit(); handleMenuClick(e); }}>Edit</button>
            <button onClick={(e) => { onDelete(relation.id); handleMenuClick(e); }}>Remove</button>
          </div>
        </foreignObject>
      )}
    </g>
  );
};

export default Relation;